var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    [
      _c(
        "h3",
        { staticClass: "headline" },
        [_c("v-list-item-title", [_vm._v("Azioni disponibili")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.azioniPossibili.length > 0
                ? _vm._l(_vm.azioniPossibili, function (azione) {
                    return _c(
                      "v-flex",
                      { key: azione, attrs: { xs12: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { block: "", color: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.eseguiAzione(azione)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("azioneLavorazioneDesc")(azione)
                                ) +
                                " "
                            ),
                            _c("v-icon", { attrs: { right: "" } }, [
                              _vm._v("cloud_upload"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  })
                : _c("v-alert", { attrs: { type: "info", value: true } }, [
                    _vm._v(
                      " Non ci sono azioni possibili da effettuare per le lavorazioni selezionate. "
                    ),
                  ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "80%" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm._f("azioneLavorazioneDesc")(_vm.azione))),
              ]),
              _c(
                "loading",
                {
                  attrs: {
                    visible: _vm.isLoading,
                    message: "Caricamento dati...",
                  },
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.isNegoziazione
                            ? _c(
                                "v-card-text",
                                { staticStyle: { padding: "0 20px" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        border: "1px solid gainsboro",
                                        padding: "0 20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          ref: "menu1",
                                          attrs: {
                                            "offset-y": "",
                                            transition: "scale-transition",
                                            "max-width": "290px",
                                            "min-width": "90px",
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            "persistent-hint":
                                                              "",
                                                            label:
                                                              "Nuova data proposta",
                                                            "prepend-icon":
                                                              "event",
                                                          },
                                                          on: {
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              _vm.date =
                                                                _vm.parseDate(
                                                                  _vm.dateFormatted
                                                                )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.dateFormatted,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.dateFormatted =
                                                                $$v
                                                            },
                                                            expression:
                                                              "dateFormatted",
                                                          },
                                                        },
                                                        on
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2042534905
                                          ),
                                          model: {
                                            value: _vm.menu1,
                                            callback: function ($$v) {
                                              _vm.menu1 = $$v
                                            },
                                            expression: "menu1",
                                          },
                                        },
                                        [
                                          _c("v-date-picker", {
                                            attrs: { "no-title": "" },
                                            on: {
                                              input: function ($event) {
                                                _vm.menu1 = false
                                              },
                                            },
                                            model: {
                                              value: _vm.date,
                                              callback: function ($$v) {
                                                _vm.date = $$v
                                              },
                                              expression: "date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-list",
                                [
                                  _vm._l(
                                    _vm.lavorazioniSelezionate,
                                    function (lav, i) {
                                      return [
                                        i > 0
                                          ? _c("v-divider", { key: `d_${i}` })
                                          : _vm._e(),
                                        _c(
                                          "v-list-item",
                                          { key: lav.id },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(lav.codiceLAK)
                                                    ),
                                                  ]),
                                                  _vm._v(", Modello: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        lav.modello &&
                                                          lav.modello
                                                            .descrizione
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(", Fase: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        lav.fase &&
                                                          lav.fase.descrizione
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(", Lotto: "),
                                                  _c("strong", [
                                                    _vm._v(_vm._s(lav.lotto)),
                                                  ]),
                                                  _vm._v(", Consegna: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(lav.codiceConsegna)
                                                    ),
                                                  ]),
                                                  _vm._v(", Colore: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        lav.colore &&
                                                          lav.colore.descrizione
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "darken-1" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialog = false
                                    },
                                  },
                                },
                                [_vm._v("Annulla")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "green darken-1" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.completaAzione.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Salva")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }